var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessPageV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9172 40.102L1.73484 25.5834C0.600774 24.3581 -0.0214396 22.7283 0.000564337 21.0406C0.0225683 19.3529 0.687053 17.7406 1.85266 16.5467C3.01826 15.3528 4.59298 14.6715 6.24182 14.6478C7.89066 14.624 9.48348 15.2597 10.6814 16.4196L19.7029 25.6535L36.5994 2.59504C37.098 1.91384 37.7229 1.33985 38.4383 0.905841C39.1538 0.471831 39.9457 0.1863 40.7689 0.0655497C41.5921 -0.0552002 42.4305 -0.00880423 43.2362 0.202089C44.0419 0.412982 44.7991 0.784243 45.4647 1.29467C46.1302 1.8051 46.691 2.44471 47.115 3.17696C47.539 3.90922 47.818 4.71979 47.936 5.5624C48.0539 6.40501 48.0086 7.26315 47.8026 8.08782C47.5965 8.9125 47.2338 9.68756 46.7351 10.3688L25.4605 39.408C24.9161 40.1508 24.2221 40.7651 23.4255 41.2095C22.629 41.6539 21.7485 41.9179 20.8435 41.9837C19.9386 42.0495 19.0305 41.9156 18.1805 41.5909C17.3306 41.2663 16.5588 40.7585 15.9172 40.102Z",
    fill: "url(#paint0_linear_1221_327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1221_327",
    x1: 52,
    y1: -7,
    x2: 7,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763721,
    stopColor: "#50D58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670146,
    stopColor: "#6AA8EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPageV);
export default __webpack_public_path__ + "static/media/successPageV.e45945cdd01b0c2991632b4b0118c510.svg";
export { ForwardRef as ReactComponent };